export default __webpack_public_path__ + "static/Pomp-eed40838669455d7424aca4d8cbc533c.svg";